import { buildPlanRouteUrl } from "../../../../routes/routeCreators/utils/buildPlanRouteUrl.js";
export const buildPlanModuleRoutePath = ({ endpoint, refType, version = "v1", companyDomainId = ":companyDomainId", legalEntityId = ":legalEntityId", planId = ":planId", }) => {
    return buildPlanRouteUrl(`/modules/${refType}${endpoint}`, {
        version,
        companyDomainId,
        legalEntityId,
        planId,
    });
};
